import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import Section from "../Section";
import FeaturesSectionStyle2 from "../Section/FeaturesSection/FeaturesSectionStyle2";
import { pageTitle } from "../../helpers/PageTitle";
import { BASE_URL } from "../../helpers/api";
import { useNavigate } from "react-router-dom";
import "../../sass/shortcode/AboutBanner.scss";

const departmentData = [
  {
    title: "Ayurveda",
    subTitle:
      "Ayurvedic Consultation – Personalized health assessments based on body constitution (Prakriti) and lifestyle to identify imbalances and design holistic treatment plans.",
    imgUrl: "/images/services/ayurveda.jpg",
    slug: "ayurveda",
  },
  {
    title: "Family Physician",
    subTitle:
      "Comprehensive Health Check-ups – Routine assessments to monitor overall health and detect early signs of illness.",
    imgUrl: "/images/services/family-physician.jpg",
    slug: "family-physician",
  },
  {
    title: "Counseling & Psychotherapy",
    subTitle:
      "Individual Counseling – One-on-one sessions addressing stress, anxiety, depression, and emotional well-being.",
    imgUrl: "/images/services/counselling.jpg",
    slug: "counselling",
  },
];

const featureListData = [
  {
    title: " Trusted <br />Ayurvedic Expertise",
    subTitle:
      "We provide authentic Ayurvedic consultation <br />and family health guidance to help you <br />achieve long-term wellness and balance naturally.",
    iconUrl: "images/icons/professional.svg",
  },
  {
    title: " Convenient Online Consultations",
    subTitle:
      "Book appointments online and consult with <br />our doctor from the comfort of your home, <br />saving time and making healthcare more accessible.",
    iconUrl: "images/icons/comprehensive.svg",
  },
  {
    title: " Holistic & <br />Personalized Care",
    subTitle:
      "Every patient is unique — we focus on <br />understanding your health concerns deeply <br />and offer tailored treatment plans that suit your lifestyle.",
    iconUrl: "images/icons/patient.svg",
  },
  {
    title: " Simple & <br />Transparent Process",
    subTitle:
      "From booking appointments to receiving <br />prescriptions, everything is clear, quick, and <br />easy to follow — no hidden steps, no confusion.",
    iconUrl: "images/icons/facilities.svg",
  },
];

export default function About() {
  pageTitle("About");

  const [teamData, setTeamData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(`${BASE_URL}/doctors/doc`);
        const data = await response.json();

        const formatted = data.slice(0, 3).map((doc) => ({
          imgUrl: doc.imgUrl || "images/about/aboutimg3.webp",
          name: doc.name,
          designation: doc.specialist,
          description: doc.short_biography,
          social: [
            { icon: "fa6-brands:facebook-f", href: doc.facebook || "#" },
            { icon: "fa6-brands:linkedin-in", href: doc.linkedin || "#" },
            { icon: "fa6-brands:twitter", href: doc.twitter || "#" },
          ],
        }));

        setTeamData(formatted);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };

    fetchDoctors();
  }, []);

  return (
    <>
      {/* 🟩 Top Banner Section */}
      <section className="cs_about_banner">
        <span className="cs_about_dots" />
        <div className="container">
          <div className="cs_about_banner_row">
            <div className="cs_about_banner_left">
              <span className="cs_about_label">
                <span className="cs_about_label_icon">
                  <Icon icon="mdi:leaf" />
                </span>
                Caring For You, Always
              </span>
              <h1>
                Welcome to
                <span className="cs_about_gradient_text">
                  Medayus Medical &amp; Healthcare Center
                </span>
              </h1>
              <span className="cs_about_underline" />
              <p>
                Your trusted partner in health and wellness.
                <br />
                We are here to care for you and your family.
              </p>
              <div className="cs_about_features">
                <div className="cs_about_feature">
                  <span className="cs_about_feature_icon">
                    <Icon icon="mdi:shield-check-outline" />
                  </span>
                  <span className="cs_about_feature_label">
                    Trusted Care You Can Rely On
                  </span>
                </div>
                <div className="cs_about_feature">
                  <span className="cs_about_feature_icon">
                    <Icon icon="mdi:hand-heart-outline" />
                  </span>
                  <span className="cs_about_feature_label">
                    Compassionate &amp; Friendly Staff
                  </span>
                </div>
                <div className="cs_about_feature">
                  <span className="cs_about_feature_icon">
                    <Icon icon="mdi:heart-pulse" />
                  </span>
                  <span className="cs_about_feature_label">
                    Advanced Care Better Outcomes
                  </span>
                </div>
              </div>
            </div>
            <div className="cs_about_banner_right">
              <div className="cs_about_img_wrap">
                <img
                  src="/images/about/banner_wellness_photo.png"
                  alt="Medayus Medical & Healthcare Center"
                />
              </div>
            </div>
          </div>
        </div>
        <span className="cs_about_wave" />
      </section>

      {/* 🟩 Services Section */}
      <Section topMd={100} topLg={50} topXl={60}>
        <div
          style={{
            textAlign: "center",
            marginBottom: "50px",
          }}
        >
          <h3>SERVICES</h3>
          <h2>We Provide Our Best Services</h2>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "30px",
            padding: "40px 80px",
          }}
        >
          {departmentData.map((dept, index) => (
            <div
              key={index}
              onClick={() => navigate(`/services/${dept.slug}`)} // 👈 Navigation added here
              style={{
                cursor: "pointer",
                border: "1px solid #e0e0e0",
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                backgroundColor: "#fff",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
              }}
            >
              <img
                src={dept.imgUrl}
                alt={dept.title}
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                }}
              />
              <div style={{ padding: "30px" }}>
                <h3>{dept.title}</h3>
                <p>{dept.subTitle}</p>
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* 🟩 Why Choose Us */}
      <Section topMd={90} topLg={50} topXl={50} bottomMd={90} bottomLg={60}>
        <FeaturesSectionStyle2
          sectionTitle="Why Choose Us"
          imgUrl="images/about/Support.jpg"
          data={featureListData}
        />
      </Section>

      {/* 🟩 Footer Banner */}
      <Section className="cs_about_cta_banner" bottomMd={190} bottomLg={170} bottomXl={140}>
        <BannerSectionStyle4
          bgUrl="images/about/background.jpg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment today!"
          center
        />
      </Section>
    </>
  );
}
